import { useEffect, useState } from "react";

const useCheckLargeDesktopScreen = () => {
    const [width, setWidth] = useState<undefined | number>();
    const handleWindowSizeChange = () => {
        setWidth(window.innerWidth);
    };

    useEffect(() => {
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setWidth(window.innerWidth);
        window.addEventListener("resize", handleWindowSizeChange);
        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);

    return (width && width >= 1980);
};

export default useCheckLargeDesktopScreen;
